// extracted by mini-css-extract-plugin
export var buttons = "ConfirmModalStocktake-module--buttons--8mI36";